import { NgModule } from 'ng-metadata/core';
import { FormCountryComponent } from './country.component';
import './country.scss';

@NgModule({
  declarations: [
    FormCountryComponent,
  ],
})
export class FormCountryModule { }



// WEBPACK FOOTER //
// ./resources/assets/js/common/forms/country/country.module.ts